export const useMidpoint = () => {
    return {
        isMidpointHost: window.location.hostname === "portal.midpointef.com",
    }
};
